import { Checkbox, FormControlLabel } from "@mui/material";
import { useUrlFilterTags } from "hooks/filterHooks";
import { FrontendFilterTag } from "types/types";

interface Props {
  tag: FrontendFilterTag;
}

export function Leaf(props: Props) {
  const { tag } = props;
  const { tagIds, updateTags } = useUrlFilterTags();
  function onChange() {
    updateTags(tag.id);
  }
  return (
    <FormControlLabel
      label={tag.name}
      control={
        <Checkbox
          onChange={onChange}
          checked={tagIds.includes(tag.id)}
          value={tag.completeKey}
        />
      }
    />
  );
}
